module.exports = __webpack_public_path__ + "img/ICONO13.b4361764.png";